import { AxiosInstance } from 'axios';
import { AgreeToVideoStreamingTermsRepository } from '@/model/repository/manager/video/AgreeToVideoStreamingTermsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AgreeToVideoStreamingTermsRepository => ({
    update() {
      return Repository.post(`${resource}`);
    },
  });
